import { NavigationGuardNext, Route, RouteRecord } from "vue-router";
import firebase from "firebase";

const authServer = process.env.VUE_APP_AUTHENTICATION_URL;

function isAuthenticated(): boolean {
  return false;
  // return !!localStorage.getItem('user');
}

export default async function processRoute(
  to: Route,
  from: Route,
  next: NavigationGuardNext,
  store: any, // Vuex.Store
  isAdmin: boolean
): Promise<void> {
  async function fetchCurrentUserIfNeeded() {
    // Fetch current user
    if (isAuthenticated() && !store.getters.currentUser) {
      await store.dispatch("fetchCurrentUser");
    }
  }

  async function loginByToken(toRoute: Route, nextRoute: NavigationGuardNext) {
    await store.dispatch("tokenLogin", toRoute.query["login-token"]);
    const { query } = toRoute;
    delete query["login-token"];
    return nextRoute({
      name: toRoute.name as string,
      params: toRoute.params,
      query,
    });
  }

  // If login token is passed
  if (to.query["login-token"]) {
    return loginByToken(to, next);
  }

  // If the route is public, let it pass
  if (to.matched.some((record: RouteRecord) => record.meta.publicAccess)) {
    return next();
  }

  // Redirect to Login if not authenticated
  if (!isAuthenticated()) {
    // const remoteConfig = firebase.remoteConfig();
    // const isPortalEnabled = remoteConfig.getValue('is_portal_enabled').asBoolean();
    // if (isPortalEnabled) {
    // } else {
    // }
    window.location.href = `${authServer}?redirect=${window.location.href}${
      isAdmin ? "&isAdmin=true" : ""
    }`;
  }

  await fetchCurrentUserIfNeeded();

  return next();
}
